import { Link } from '@tanstack/react-router'
import { TriangleAlert } from 'lucide-react'
import { cn } from '~/utils'

type Props = { botId: string; issuesCount?: number }

export const IssuesBadge = ({ botId, issuesCount = 0 }: Props) => {
  return (
    <Link
      className="text-gray-11 no-underline hover:text-accent-11"
      from="/workspaces/$workspaceId/home"
      to="/workspaces/$workspaceId/bots/$botId/issues"
      params={{ botId }}
    >
      <div
        className={cn('flex items-center gap-1', {
          'rounded bg-red-3 p-0.5 px-1 text-red-11 hover:bg-red-4': issuesCount > 0,
          'text-gray-11': issuesCount === 0,
        })}
      >
        <TriangleAlert size={16} />
        <span className="text-xs">{issuesCount}</span>
      </div>
    </Link>
  )
}
